import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectAllLabel: {
    id: 'COMMON.MULTIFILTERSCHEMA.LABEL.SELECTALL',
    defaultMessage: 'Select All'
  }
});
